// extracted by mini-css-extract-plugin
export default {"confirmContents":"ConfirmPDF_confirmContents__0YGlw","PDF_style":"ConfirmPDF_PDF_style__4Ual0"};